/* eslint-disable max-lines */
import {getStoreId} from 'constants/store';
import {formatString} from 'libs/utils/utils';
import {SITE_ID} from './app';

// NOTE! glassespage/react/getSession is used in mobile.html

let cookie = null;

if (__NODEJS__) {
    // It wont be fixed since we have to require it dynamically
    // eslint-disable-next-line @typescript-eslint/no-var-requires,prefer-destructuring
    cookie = require('../../server/app/libs/store').asyncLocalStorage.getStore()?.cookies;
}

export const ENDPOINTS = {
    CUSTOMER_TOKEN: 'customer/token',
    CUSTOMER_SELF: 'customer/me',
    CUSTOMER_CURRENT: 'customer/api/current',
    CUSTOMER_LOGOUT: 'customer/account/logout',
    CART_REORDER: 'api/rest/optimaxcheckout/v2/cart/direct',
    CUSTOMER_REGISTRATE: 'customer/registration',
    CUSTOMER_FORGOT_PASSWORD: 'customer/account/forgotPasswordPost?ajax=1',
    CUSTOMER_SUBSCRIBE_AJAX: 'v2/email/subscribe',
    CUSTOMER_ADDRESS: 'api/rest/customer/address',
    SUCCESS_PAYMENTS: 'api/rest/sales/orderLast',
    CUSTOMER_GET_ORDER: 'api/rest/sales/order',
    CUSTOMER_RESET_PASSWORD: 'customer/password',
    CUSTOMER_GET_REVIEW: 'api/rest/review/customer',
    CUSTOMER_FETCH_PRESCRIPTION: 'api/rest/customer/prescription/last',
    CUSTOMER_PRESCRIPTIONS: 'customer/v2/prescription',
    CUSTOMER_GET_SET_PRESCRIPTIONS: 'api/rest/customer/prescriptions',
    CUSTOMER_MY_FIT: 'statistic/customer/myfit',
    ROUTE_GET_INFO_BY_PATHNAME: formatString.bind(null, `route/${getStoreId(cookie)}{{url}}`),
    GET_STORE_INFO: `api/rest/store_info`,
    BRONTO_EMAIL_CAPTURE: 'emailcapture/index/capture',
    BRONTO_SUBSCRIBE: 'api/rest/bronto/subscribe',
    BRONTO_REPORT: 'directbronto/gate/report',
    ADD_TO_CART_V2: 'api/rest/optimaxcheckout/v2/cart/items',
    CART_V2: 'api/rest/optimaxcheckout/v2/cart',
    CART_GET_PAYMENT_BUTTONS: 'optimaxcart/payments/getButtons',
    CART_PUT_GET_QUOTE_ITEM_V2: 'api/rest/optimaxcheckout/v2/cart/item',
    CART_GET_QUOTE_ITEM: 'optimaxcart/react/getQuoteItem',
    CART_UPDATE_LENSES: 'checkout/cart/updateItemOptions/id',
    CART_REMOVE_QUOTE_ITEM: 'optimaxcart/react/removeItem/id',
    CART_GET_COUNT: 'api/rest/checkout/cart/count',
    CART_GET_BANNER: 'optimaxcart/react/getBanner',
    CART_GET_QUOTE: 'optimaxcart/react/getQuote',
    CART_CHANGE_ITEM_QTY: 'glassescheckout/mobile/updatePost',
    CART_ADD_COUPON: 'optimaxcart/react/applyCoupon',
    CART_REMOVE_COUPON: 'optimaxcart/react/removeCoupon',
    CART_ADD_UPSELL: 'optimaxcart/react/addOption',
    CART_REMOVE_UPSELL: 'optimaxcart/react/removeOption',
    CART_GET_ACCESSORIES: 'api/rest/accessories',
    CART_ADD_ACCESSORY: 'checkout/react/addtocart',
    CATEGORY_GET_INFO: 'api/rest/catalog/category',
    CATEGORY_GET_ITEMS: 'api/rest/catalog/product',
    CATEGORY_GET_COUNT: 'api/rest/catalog/category/filter/numbers',
    CATEGORY_GET_FILTERS: formatString.bind(null, 'api/rest/catalog/category/{{id}}/filter'),
    FETCH_SEARCH_RESULTS: 'api/rest/celebros/salesperson/search',
    CHECKOUT_GET_SHIPPING: 'optimaxcheckout/shipping',
    CHECKOUT_SET_SHIPPING: 'glassescheckout/onepage_sdk/saveShippingMethod',
    CHECKOUT_GET_PAYMENTS: 'optimaxcheckout/payment',
    PAYMENTS_OS_SETTINGS: 'payments-os/settings',
    PAYMENT_GET_REVIEW_DATA: 'optimaxcheckout/payment/reviewData', // todo Mary strange
    CHECKOUT_SET_AMAZON: 'amazon_payments/onepage/saveWidget',
    GET_PAYMENT_DATA: 'api/rest/payment/collect',
    CHECKOUT_SET_PAYMENT: 'optimaxcheckout/payment/save',
    ADDRESSES_SAVE: 'optimaxcheckout/address/save',
    ADDRESSES_GET: 'optimaxcheckout/address/getAddresses',
    ADDRESSES_GET_UNAUTHORIZED: 'optimaxcheckout/address',
    ADDRESSES_REMOVE: 'optimaxcheckout/address/remove',
    COUNTRIES_GET: 'directory/country',
    REGIONS_GET: formatString.bind(null, `directory/country/{{country}}/region`),
    CHECKOUT_GET_TOTALS: 'api/rest/checkout/cart/totals',
    CHECKOUT_GET_TOTALS_V2: '/api/rest/optimaxcheckout/v2/cart/totals',
    CHECKOUT_PLACE_ORDER: 'checkout/onepage/saveOrder',
    CHECKOUT_PLACE_ORDER_AMAZON: 'checkout/onepage/saveOrder/form_key', // todo Mary strange
    CHECKOUT_PLACE_ORDER_APPLEPAY: 'api/rest/apple_pay/order',
    CHECKOUT_GET_ORDER_ITEMS: 'optimaxcheckout/summary/itemsData',
    CHECKOUT_GET_APPLE_CLIENT_SECRET: 'optimaxcheckout/payment/paymentintent',
    CMS_GET_BY_PLACEHOLDER: 'api/rest/cms/affiliate',
    CMS_GET_BY_ID: 'api/rest/cms/block',
    CMS_GET_PAGE: 'api/rest/cms/page',
    CMS_GET_CUSTOM_POPUP: 'glassescms/popup/getCustomPopup',
    CONTACT_US: 'contacts/index/post',
    ORDERTRACKING_GET_STATUS: formatString.bind(
        null,
        'api/rest/ordertracking/tracking/{{orderNumber}}/{{email}}',
    ),
    PRODUCT_GET_V2: 'api/rest/v2/catalog/product',
    PRODUCT_GET_V3: 'api/rest/v3/catalog/product',
    PRODUCT_GET_ELASTIC: `api/rest/v4/catalog/product`,
    UPSELL_GET_BY_IDS: 'api/rest/catalog/products/upsell',
    PRODUCT_GET_WIZARD: formatString.bind(null, 'api/rest/catalog/product/{{id}}/wizard'),
    PRODUCT_GET_DISCOUNT_PRICE: formatString.bind(
        null,
        'api/rest/catalog/product/{{productId}}/price',
    ),
    PRODUCT_GET_BANNER: 'catalog/react_banner/getBanner',
    PRODUCT_GET_BANNER_COUPON: 'glassesbannersystem/product/getPackagesReminder',
    REVIEWS_GET: formatString.bind(
        null,
        'glassescatalog/react_product/reviewsList/productId/{{productId}}/limit/{{limit}}/offset/{{offset}}',
    ),
    REVIEWS_CREATE: `review/${SITE_ID}/createReview`,
    REVIEW_PHOTO: 'review/photo',
    GET_REVIEWS_BY_PRODUCT_IDS: `review/${SITE_ID}/reviews`,
    WIZARD_GET: 'api/rest/wizard',
    QUOTE_RECOVER: 'api/rest/optimaxcheckout/v2/cart/recovery',
    QUIZ_SUBSCRIPTION_INFO: '/newsletter/subscriber/info',
    ORDER_GET: 'api/rest/order',
    ORDER_SEND_PRESCRIPTION: formatString.bind(null, 'api/rest/order/{{orderId}}/item/{{itemId}}'),
    ORDER_CREATE_ZENDESK_TICKET: 'api/rest/order/zendesk/send',
    ORDER_CREATE_PAYMENT: formatString.bind(null, 'api/rest/order/{{orderId}}/payments'),
    PAIRFECT_MATCH_RESULTS: 'api/rest/catalog/category/quiz',
    TRYON_SET_CURRENT_IMAGE: 'mirror/image/setCurrent',
    TRYON_GET_COLLECTION: 'mirror/react/imagesCollection',
    TRYON_GET_RELATED_PHOTOS: 'mirror/react/getRelatedPhotos',
    TRYON_UPLOAD_IMAGE: 'mirror/wizard/upload',
    TRYON_SET_ADJUST: 'mirror/wizard/adjustsave',
    TRYON_GET_IMAGES: 'mirror/react/getImages',
    ANALYTICS_SET_FILTERS: 'glassescatalog/react_analytics/filter',
    BLOG_GET_POST: 'api/rest/blog/post',
    API_URL_WIZARD: 'api/rest/v2/wizard',
    WISHLIST: 'wishlist',
    ELASTIC: `elastic/${getStoreId(cookie)}/products/0`,
    ELASTIC_CATEGORY: `elastic/v2/${getStoreId(cookie)}/products`,
    ELASTIC_CATEGORY_FILTERS: `elastic/v2/${getStoreId(cookie)}/filters`,
    ELASTIC_GET_PRODUCT_V2: formatString.bind(
        null,
        `elastic/v2/${getStoreId(cookie)}/product/{{id}}`,
    ),
    POST_PURCHASE_INSURANCE_ORDER: formatString.bind(null, 'api/rest/insurance/order/{{token}}'),
    POST_PURCHASE_INSURANCE_COLLECT_TOTALS: formatString.bind(
        null,
        `api/rest/insurance/order/{{token}}/collectTotals`,
    ),
    FETCH_REORDER: 'api/rest/optimaxcheckout/v2/cart/reorder',
    REORDER_EMAIL: 'api/rest/order/reorder/cl',
    PRODUCT_PRICE: formatString.bind(null, 'api/rest/catalog/product/{{id}}/price'),
    FETCH_REVIEWS: 'review/1/review/product',
    FETCH_TRUSTPILOT_REVIEWS: 'bff/trustpilot/header',
    POST_ORDER_TRACKING: 'api/rest/tracking',
    POST_ORDER_TRACKING_PRESCRIPTION: '/api/rest/tracking/prescription',
    FETCH_EXAMS: 'exam/exam',
    GET_CL_SUBSCRIPTION_PLANS: formatString.bind(null, 'subscription/product/{{id}}/plans'),
    NEWSLETTER_SUBSCRIPTION_INFO: 'newsletter/subscriber/info',
    ELASTIC_AUTOCOMPLETE: `elastic/${getStoreId(cookie)}/autocomplete`,
};
